import { required, yup } from "./CommonValidation";
import * as Yup from 'yup';
export const FaqSchema = (type) => { 
    if (type === 'add') {
        return yup({
            question: required("Please enter question"),
            ans: required("Please enter answer")
        });
    } 
};